import { useState } from 'react';
import { useAuth } from '@/contexts/auth-context';
import { toast } from '@/hooks/use-toast';

export const useBangCanDoiPhatSinhCongNoExport = (queryParams?: MuaHangRecord) => {
  const [isExporting, setIsExporting] = useState(false);
  const { entity } = useAuth();

  const exportToExcel = async () => {
    if (!entity?.slug) {
      toast({
        description: 'Không tìm thấy thông tin đơn vị.',
        variant: 'default'
      });
      return;
    }

    if (!queryParams) {
      toast({
        description: 'Vui lòng thực hiện tìm kiếm trước khi xuất dữ liệu.',
        variant: 'default'
      });
      return;
    }

    setIsExporting(true);
    try {
      const { exportBangCanDoiPhatSinhCongNoFromApi } = await import('../components/utils/excel-export');
      const transformedParams = {
        ...queryParams,
        ngay_ct1: queryParams.ngay_ct1?.replace?.(/-/g, '') || queryParams.ngay_ct1,
        ngay_ct2: queryParams.ngay_ct2?.replace?.(/-/g, '') || queryParams.ngay_ct2
      };

      await exportBangCanDoiPhatSinhCongNoFromApi({
        entitySlug: entity.slug,
        queryParams: transformedParams
      });
    } catch (error) {
      toast({
        description: 'Không thể kết xuất dữ liệu.',
        variant: 'destructive'
      });
    } finally {
      setIsExporting(false);
    }
  };

  return {
    exportToExcel,
    canExport: Boolean(entity?.slug && queryParams),
    isExporting
  };
};
